$(document).ready(function() {
	if(!document.querySelector('.C0028')) return false;
	
	 // LGEGMO-5525 START
	var c = {
		el: null,
		template: null,
		init: function(){
			var _this = c;
			var els = document.querySelectorAll('.C0028');

			for (var i = 0; i < els.length; i++) {
				_this.el = els[i];
				_this.template = $(_this.el).find('.contents-template').clone();
				$(_this.el).find('.contents-template').remove();

				_this.addEvent();
				$(_this.el.querySelector('form')).trigger('submit');
			}
		},
		createProductItem: function(productList){
			var html = [];

			for (var i = 0; i < productList.length; i++) {
				var p = productList[i],
					template = $(c.template).clone().html();
				template = template.replace(/\*promotionPath\*/g, p.promotionPath)
								.replace(/\*title\*/g, p.title)
								.replace(/\*thumbnailImageAddr\*/g, p.thumbnailImageAddr)
								.replace(/\*imageAltText\*/g, p.imageAltText)
								.replace(/\*adobePromotionTitle\*/g, p.adobePromotionTitle)
								.replace(/\*promotionStartDate\*/g, p.promotionStartDate)
								.replace(/\*promotionLinkUrl\*/g, p.promotionLinkUrl)
								.replace(/\*promotionEndDate\*/g, p.promotionEndDate)
								.replace(/\*promotionId\*/g, p.promotionId)/* PJTUSGA-1 : 20200318 add */
								.replace(/\*promotionIndex\*/g, i+1)/* PJTUSGA-1 : 20200318 add */
								.replace(/\*idCount\*/g, i+"t"); /* PJTWAUS-1_KJB : 20200131 add */
				/* PJTWAUS-1_KJB : 20200206 add */
				if(typeof p.imageAccDesc != "undefined" && p.imageAccDesc != null && p.imageAccDesc !=""){
					template=template.replace(/\*imageAccDesc\*/g, "<p class='hidden'>" + p.imageAccDesc + "</p>");
				}else{
					template=template.replace(/\*imageAccDesc\*/g, "");
				}
				/* // PJTWAUS-1_KJB : 20200206 add */

				var $template = $(template),
					$keyBlocks = $template.find('*[data-key]');

				for (var i1 = 0; i1 < $keyBlocks.length; i1++) {
					var $currentKeyBlock = $keyBlocks.eq(i1),
						key = $currentKeyBlock.get(0).getAttribute('data-key'),
						val = p[key];
					if(!val || (val == null || val == "N")) {
						// if($currentKeyBlock.is('.btn')) {
						// 	$currentKeyBlock.removeClass('active');
						// }else {
						// 	$currentKeyBlock.remove();
						// }
						$currentKeyBlock.remove();
					}
				}

				$template.find('.unit-box').each(function() {
					if($(this).find('.head-copy').text() == 'undefined') $(this).find('.head-copy').empty();
					if($(this).find('.body-copy').text() == 'undefined') $(this).find('.body-copy').empty();
				})

				if(p.externalLinkTarget && p.externalLinkTarget=="New") {
					$template.find('.visual-area a').attr('target', '_blank');
					$template.find('.btn-box a.btn').attr('target', '_blank');
				}

				$template.find('template').remove();
				template = $template.get(0).outerHTML;
				html += template;
			}

			return html;
		},
		addEvent: function(){ 
			var _this = c;
			$(_this.el).on({
				submit: function(e){
					e.preventDefault();
					var isExpander = $(e.delegateTarget).data('focus') == true;
					var url = e.currentTarget.action,
						param = xssfilter($(e.currentTarget).serialize());
					var $target = $(e.currentTarget).siblings('.list-wrap');

					ajax.noCacheCall(url, param, 'json', function(d){
						var data, html;
						if(d && d.data) data = d.data;

						if(d.status == "success" && data) {
							// making markup
							html = c.createProductItem(data.contents ? data.contents : data);
							$target.find('.unit-list').html(html);

							if($target.hasClass('initialized')) {
								$('html, body').animate({
									scrollTop: $target.closest('.component').offset().top
								});
							}
							// Slick
							$target.find('.unit-list').slick({
								infinite:false, 
								listStyle: false,
								slidesToShow: 3,
								slidesToScroll: 1,
								arrows : false,
								dots: false,
								responsive: [
									{
										breakpoint: 768,
										settings: {
											slidesToShow: 1,
											slidesToScroll: 1,
											dots: true
										}
									}
								]
							});
						}
					});
				}
			}, 'form');
		}
	};
//LGEGMO-5525
	c.init();
});
